var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "article-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 15,
    height: 15,
    transform: "translate(130 1586)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_292",
    "data-name": "Mask Group 292",
    transform: "translate(-130 -1586)",
    clipPath: "url(#article-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_1_",
    "data-name": "svgexport-7 (1)",
    transform: "translate(130 1586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M9.668,4.395A1.027,1.027,0,0,1,8.643,3.369V0H3.4A1.613,1.613,0,0,0,1.787,1.611V13.389A1.613,1.613,0,0,0,3.4,15h8.2a1.613,1.613,0,0,0,1.611-1.611V4.395ZM4.189,10.547H6.32a.439.439,0,0,1,0,.879H4.189a.439.439,0,0,1,0-.879Zm-.439-1.9A.439.439,0,0,1,4.189,8.2h6.445a.439.439,0,0,1,0,.879H4.189A.439.439,0,0,1,3.75,8.643Zm6.885-2.783a.439.439,0,0,1,0,.879H4.189a.439.439,0,0,1,0-.879Z",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M9.521,3.369a.147.147,0,0,0,.146.146h3.349a1.607,1.607,0,0,0-.308-.4L9.884.441A1.615,1.615,0,0,0,9.522.182V3.369Z",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/articleIcon.fc2e891af1886a46bf2c5c4a675b8cfb.svg";
export { ForwardRef as ReactComponent };